import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface GetSignedUrlResult {
  success: boolean;
  url?: string;
  error?: string;
}

export function useGetFsTeacherSlipUrl() {
  const [isLoading, setIsLoading] = useState(false);

  const getSignedUrl = async (
    salaryId: string,
    fileType: 'slip' | 'tavi50'
  ): Promise<GetSignedUrlResult> => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('get-fs-teacher-storage-signed-url', {
        body: { salaryId, type: fileType, source: 'teacher' }
      });

      if (error) {
        console.error('Get signed URL error:', error);
        toast.error('ไม่สามารถดาวน์โหลดไฟล์ได้: ' + error.message);
        return { success: false, error: error.message };
      }

      if (!data?.url) {
        toast.error('ไม่พบไฟล์');
        return { success: false, error: 'No signed URL returned' };
      }

      return { success: true, url: data.url };
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error';
      console.error('Get signed URL exception:', err);
      toast.error('เกิดข้อผิดพลาด: ' + message);
      return { success: false, error: message };
    } finally {
      setIsLoading(false);
    }
  };

  const downloadFile = async (salaryId: string, fileType: 'slip' | 'tavi50') => {
    const result = await getSignedUrl(salaryId, fileType);
    if (result.success && result.url) {
      window.open(result.url, '_blank');
    }
  };

  return { getSignedUrl, downloadFile, isLoading };
}
